<template>
  <div v-if="!loading && values" class="rating-chart-with-table">
    <div class="rating-chart-with-table__title">
      {{ title }}
    </div>
    <div class="rating-chart-with-table__chart">
      <div class="rating-chart-with-table__left-bar">
        <div class="rating-chart-with-table__percent">
          {{ formatLeftBarValue(getMax()) }}
        </div>
        <div class="rating-chart-with-table__percent">
          {{ formatLeftBarValue(getAverage()) }}
        </div>
        <div class="rating-chart-with-table__percent">0</div>
      </div>
      <div class="rating-chart-with-table__columns-table">
        <div class="rating-chart-with-table__columns" :style="getGridStyle()">
          <div class="rating-chart-with-table__col-background">
            <div class="rating-chart-with-table__col -pointer-" />
          </div>
          <div
            v-for="(week, index) in values.weeks"
            :key="index"
            class="rating-chart-with-table__col-background"
          >
            <div
              class="rating-chart-with-table__col -pointer-"
              :style="getHeight(index)"
            />
          </div>
        </div>
        <div class="rating-chart-with-table__labels" :style="getGridStyle()">
          <div class="rating-chart-with-table__label-text">Учас.</div>
          <div class="rating-chart-with-table__label-text">До курса</div>
          <div
            v-for="(week, index) in values.weeks.length - 1"
            :key="index"
            class="rating-chart-with-table__label-text"
          >
            {{ index + 1 }} н.
          </div>
        </div>
      </div>
    </div>
    <div class="rating-chart-with-table__table">
      <div
        v-for="(number, index) in 4"
        :key="index"
        class="rating-chart-with-table__table-row -pointer-"
        :class="{ '-active-': index === value }"
        @click="$emit('input', index)"
      >
        <div class="rating-chart-with-table__table-row-title">
          {{ getTitle(index) }}
        </div>
        <div
          class="rating-chart-with-table__table-data"
          :style="getGridStyle()"
        >
          <div class="rating-chart-with-table__table-col">
            {{ index === 0 ? values.totalUser : '' }}
          </div>
          <div
            v-for="(item, index2) in values.weeks"
            :key="index2"
            class="rating-chart-with-table__table-col"
          >
            {{ getFormattedValue(getValueByIndexes(index, index2)) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import numberFormat from '@/filters/numberFormat.filter';

export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    values: {
      type: Object,
      default: null
    },
    value: {
      type: Number
    }
  },
  methods: {
    getGridStyle(add = 1) {
      if (this.values) {
        return (
          'grid-template-columns: repeat(' +
          (this.values.weeks.length + add) +
          ', 1fr)'
        );
      } else {
        return 'grid-template-columns: repeat(5, 1fr)';
      }
    },
    getTitle(index) {
      switch (index) {
        case 0:
          return 'Людей';
        case 1:
          return 'Зап-ть %';
        case 2:
          return 'Всего ₽';
        case 3:
          return 'Сред-е ₽';
      }
    },
    getValueByIndexes(index, index2) {
      return this.values.weeks[index2][this.getVarName(index)];
    },
    getVarName(index) {
      switch (index) {
        case 0:
          return 'fill';
        case 1:
          return 'fillPercent';
        case 2:
          return 'sum';
        case 3:
          return 'avSum';
      }
    },
    getFormattedValue(value) {
      return numberFormat(value, this.noDot);
    },
    formatLeftBarValue(value) {
      return this.getFormattedValue(Math.round(value));
    },
    getWeeks() {
      return this.values.weeks.map(week => week[this.getVarName(this.value)]);
    },
    getMax() {
      return this.value === 0
        ? this.values.totalUser
        : Math.max.apply(null, this.getWeeks());
    },
    getAverage() {
      return this.getMax() / 2;
    },
    getHeight(index) {
      const weeks = this.getWeeks();
      const max = this.getMax();
      let percent = 100 / (max / weeks[index]);

      if (percent < 2) {
        percent = 2;
      }
      return 'max-height: ' + percent + '%';
    }
  }
};
</script>
